import { connect } from 'react-redux';
import { track } from '../actions/mixpanel';
import { getFolderPermissionForUser, getUser } from '../actions/user';
import Invite from '../components/Invite.js';

const mapDispatchToProps = {track, getFolderPermissionForUser, getUser};

const mapStateToProps = (state, ownProps) => {
  return {
    invite: state.invites.byId[ownProps.match.params.inviteId] || {},
    isMobileWelcomeAcknowledged: state.ui.isMobileWelcomeAcknowledged
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Invite);
